import { gql } from "@apollo/client";

const SECTION_FIELDS = `
  id layoutId position type title subtitle badge cardStyle collectionId collectionName
  config visibleCount seeAllLabel audience startAt endAt isActive minAppVersion
`;

export const GET_HOME_LAYOUTS = gql`
  query GetHomeLayouts($gender: String) {
    getHomeLayouts(gender: $gender) {
      status
      message
      layouts { id name gender status startAt endAt version publishedAt updatedAt }
    }
  }
`;

export const GET_HOME_LAYOUT = gql`
  query GetHomeLayout($id: ID!) {
    getHomeLayout(id: $id) {
      status
      message
      layout {
        id name gender status startAt endAt theme searchHints version publishedAt updatedAt
        sections { ${SECTION_FIELDS} }
      }
    }
  }
`;

export const GET_COLLECTIONS = gql`
  query GetCollections {
    getCollections {
      status
      message
      collections {
        id name source rule sort pinnedServiceIds isActive usedInSections updatedAt
        items { serviceId position badge serviceName price }
      }
    }
  }
`;

export const GET_CATALOG = gql`
  query GetHomeBuilderCatalog($gender: String!) {
    getHomeBuilderCatalog(gender: $gender) {
      categories { id name }
      products { id name }
      services { id name catalogueName price categoryId categoryName productName isPackage image }
    }
  }
`;

const FEED_FIELDS = `
  layoutId layoutVersion audience searchHints
  sections {
    id type title subtitle cardStyle totalCount chips isPersonal
    services { id name price campaignPrice ratingAvg ratingCount bookedLast30Days isPackage variant shortDescription badge durationMinutes image }
    banners { id image }
    categories { id name image }
    coupons { code title description minOrder newCustomersOnly }
    liveBookings { beauticianFirstName serviceSummary status }
    ratingPrompt { serviceSummary beauticianFirstName rewardText }
    trust { completedServices customers ratingAvg ratingCount bookingsLast30Days promises brands }
    refer { referrerReward refereeReward minOrder }
    consult { body ctaLabel }
    packageBuilder { title subtitle minItems maxPercent }
    occasions { categoryId name image fromPrice }
    journey { title body }
    faqs { question answer }
  }
`;

export const PREVIEW_HOME_FEED = gql`
  query PreviewHomeFeed($layoutId: ID!, $audience: String) {
    previewHomeFeed(layoutId: $layoutId, audience: $audience) {
      status
      message
      feed { ${FEED_FIELDS} }
    }
  }
`;

export const PREVIEW_COLLECTION = gql`
  query PreviewCollection($data: CollectionInput!, $gender: String) {
    previewCollection(data: $data, gender: $gender) {
      status
      message
      totalCount
      services { id name price isPackage variant ratingAvg ratingCount bookedLast30Days image }
    }
  }
`;

const mutation = (name, signature, call) => gql`
  mutation ${name}${signature} {
    ${call} { status message id }
  }
`;

export const SAVE_HOME_LAYOUT = mutation("SaveHomeLayout", "($data: HomeLayoutInput!)", "saveHomeLayout(data: $data)");
export const PUBLISH_HOME_LAYOUT = mutation("PublishHomeLayout", "($id: ID!)", "publishHomeLayout(id: $id)");
export const ARCHIVE_HOME_LAYOUT = mutation("ArchiveHomeLayout", "($id: ID!)", "archiveHomeLayout(id: $id)");
export const DUPLICATE_HOME_LAYOUT = mutation("DuplicateHomeLayout", "($id: ID!, $name: String!)", "duplicateHomeLayout(id: $id, name: $name)");
export const DELETE_HOME_LAYOUT = mutation("DeleteHomeLayout", "($id: ID!)", "deleteHomeLayout(id: $id)");
export const SAVE_HOME_SECTION = mutation("SaveHomeSection", "($data: HomeSectionInput!)", "saveHomeSection(data: $data)");
export const DELETE_HOME_SECTION = mutation("DeleteHomeSection", "($id: ID!)", "deleteHomeSection(id: $id)");
export const REORDER_HOME_SECTIONS = mutation("ReorderHomeSections", "($layoutId: ID!, $sectionIds: [ID!]!)", "reorderHomeSections(layoutId: $layoutId, sectionIds: $sectionIds)");
export const SAVE_COLLECTION = mutation("SaveCollection", "($data: CollectionInput!)", "saveCollection(data: $data)");
export const DELETE_COLLECTION = mutation("DeleteCollection", "($id: ID!)", "deleteCollection(id: $id)");
